// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.definition-besoin {
  min-height: 80px;
  white-space: pre-wrap;
}

`, "",{"version":3,"sources":["webpack://./src/composants/Consultation/Consultation.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".definition-besoin {\n  min-height: 80px;\n  white-space: pre-wrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
